import { PersonGrid } from '@/features/PersonGrid';

export default function PersonsPage() {
    return <PersonGrid />;
}
